
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("volta/_pods/application/adapter", function(){ return i("volta/_pods/application/adapter.ts");});
d("volta/_pods/application/loading", function(){ return i("volta/_pods/application/loading.ts");});
d("volta/_pods/application/serializer", function(){ return i("volta/_pods/application/serializer.ts");});
d("volta/adapters/forecast-project-task", function(){ return i("volta/adapters/forecast-project-task.ts");});
d("volta/adapters/planning-supply-alternative", function(){ return i("volta/adapters/planning-supply-alternative.ts");});
d("volta/adapters/po-task", function(){ return i("volta/adapters/po-task.ts");});
d("volta/adapters/simulation-item-setting-task", function(){ return i("volta/adapters/simulation-item-setting-task.ts");});
d("volta/adapters/simulation-task", function(){ return i("volta/adapters/simulation-task.ts");});
d("volta/adapters/sku-task", function(){ return i("volta/adapters/sku-task.ts");});
d("volta/app", function(){ return i("volta/app.ts");});
d("volta/authenticators/session", function(){ return i("volta/authenticators/session.ts");});
d("volta/breakpoints", function(){ return i("volta/breakpoints.js");});
d("volta/config/environment", function(){ return i("volta/config/environment.js");});
d("volta/formats", function(){ return i("volta/formats.ts");});
d("volta/instance-initializers/application", function(){ return i("volta/instance-initializers/application.ts");});
d("volta/locales", function(){ return i("volta/locales.ts");});
d("volta/macros/arg-or-default", function(){ return i("volta/macros/arg-or-default.ts");});
d("volta/macros/tracked", function(){ return i("volta/macros/tracked.ts");});
d("volta/models/activity", function(){ return i("volta/models/activity.ts");});
d("volta/models/adu-profile", function(){ return i("volta/models/adu-profile.ts");});
d("volta/models/app-feature", function(){ return i("volta/models/app-feature.ts");});
d("volta/models/base-model", function(){ return i("volta/models/base-model.ts");});
d("volta/models/bom-node", function(){ return i("volta/models/bom-node.ts");});
d("volta/models/bom", function(){ return i("volta/models/bom.ts");});
d("volta/models/buffer-profile", function(){ return i("volta/models/buffer-profile.ts");});
d("volta/models/buffer", function(){ return i("volta/models/buffer.ts");});
d("volta/models/bv-flash", function(){ return i("volta/models/bv-flash.ts");});
d("volta/models/collection-view", function(){ return i("volta/models/collection-view.ts");});
d("volta/models/config", function(){ return i("volta/models/config.ts");});
d("volta/models/constants/acquisition-codes", function(){ return i("volta/models/constants/acquisition-codes.ts");});
d("volta/models/constants/adu", function(){ return i("volta/models/constants/adu.ts");});
d("volta/models/constants/app-features-columns", function(){ return i("volta/models/constants/app-features-columns.ts");});
d("volta/models/constants/buffer-zones", function(){ return i("volta/models/constants/buffer-zones.ts");});
d("volta/models/constants/custom-fields", function(){ return i("volta/models/constants/custom-fields.ts");});
d("volta/models/constants/date-filters", function(){ return i("volta/models/constants/date-filters.ts");});
d("volta/models/constants/entity-types", function(){ return i("volta/models/constants/entity-types.ts");});
d("volta/models/constants/filters/boms", function(){ return i("volta/models/constants/filters/boms.ts");});
d("volta/models/constants/formula-recipes", function(){ return i("volta/models/constants/formula-recipes.ts");});
d("volta/models/constants/import", function(){ return i("volta/models/constants/import.ts");});
d("volta/models/constants/job-type", function(){ return i("volta/models/constants/job-type.ts");});
d("volta/models/constants/lead-time-categories", function(){ return i("volta/models/constants/lead-time-categories.ts");});
d("volta/models/constants/on-hand-sourcing", function(){ return i("volta/models/constants/on-hand-sourcing.ts");});
d("volta/models/constants/order-cycle-strategies", function(){ return i("volta/models/constants/order-cycle-strategies.ts");});
d("volta/models/constants/order-statuses", function(){ return i("volta/models/constants/order-statuses.ts");});
d("volta/models/constants/planning-methodologies", function(){ return i("volta/models/constants/planning-methodologies.ts");});
d("volta/models/constants/reorder-strategies", function(){ return i("volta/models/constants/reorder-strategies.ts");});
d("volta/models/constants/safety-stock-formulas", function(){ return i("volta/models/constants/safety-stock-formulas.ts");});
d("volta/models/constants/schedule", function(){ return i("volta/models/constants/schedule.ts");});
d("volta/models/constants/time-buffer-alerts", function(){ return i("volta/models/constants/time-buffer-alerts.ts");});
d("volta/models/constants/user-types", function(){ return i("volta/models/constants/user-types.ts");});
d("volta/models/constants/var-categories", function(){ return i("volta/models/constants/var-categories.ts");});
d("volta/models/constants/widgets", function(){ return i("volta/models/constants/widgets.ts");});
d("volta/models/custom-field-definition", function(){ return i("volta/models/custom-field-definition.ts");});
d("volta/models/daf-profile", function(){ return i("volta/models/daf-profile.ts");});
d("volta/models/dashboard-summary", function(){ return i("volta/models/dashboard-summary.ts");});
d("volta/models/demand-forecast", function(){ return i("volta/models/demand-forecast.ts");});
d("volta/models/execution-alert", function(){ return i("volta/models/execution-alert.ts");});
d("volta/models/external-forecast", function(){ return i("volta/models/external-forecast.ts");});
d("volta/models/forecast-project-header", function(){ return i("volta/models/forecast-project-header.ts");});
d("volta/models/forecast-project-ml-pipeline", function(){ return i("volta/models/forecast-project-ml-pipeline.ts");});
d("volta/models/forecast-project-task", function(){ return i("volta/models/forecast-project-task.ts");});
d("volta/models/forecast-project", function(){ return i("volta/models/forecast-project.ts");});
d("volta/models/import-histo", function(){ return i("volta/models/import-histo.ts");});
d("volta/models/job-histo", function(){ return i("volta/models/job-histo.ts");});
d("volta/models/jsonapi-infinity-model", function(){ return i("volta/models/jsonapi-infinity-model.ts");});
d("volta/models/order-sync-alert", function(){ return i("volta/models/order-sync-alert.ts");});
d("volta/models/order", function(){ return i("volta/models/order.ts");});
d("volta/models/part-type", function(){ return i("volta/models/part-type.ts");});
d("volta/models/part", function(){ return i("volta/models/part.ts");});
d("volta/models/planning-order", function(){ return i("volta/models/planning-order.ts");});
d("volta/models/planning-setting-rule", function(){ return i("volta/models/planning-setting-rule.ts");});
d("volta/models/planning-setting", function(){ return i("volta/models/planning-setting.ts");});
d("volta/models/planning-supply-alternative", function(){ return i("volta/models/planning-supply-alternative.ts");});
d("volta/models/planning", function(){ return i("volta/models/planning.ts");});
d("volta/models/po-group", function(){ return i("volta/models/po-group.ts");});
d("volta/models/po-task", function(){ return i("volta/models/po-task.ts");});
d("volta/models/po-validation-rule", function(){ return i("volta/models/po-validation-rule.ts");});
d("volta/models/report", function(){ return i("volta/models/report.ts");});
d("volta/models/route-operation", function(){ return i("volta/models/route-operation.ts");});
d("volta/models/route", function(){ return i("volta/models/route.ts");});
d("volta/models/schedule", function(){ return i("volta/models/schedule.ts");});
d("volta/models/search-entry", function(){ return i("volta/models/search-entry.ts");});
d("volta/models/simulation-item-planning-report", function(){ return i("volta/models/simulation-item-planning-report.ts");});
d("volta/models/simulation-item-planning", function(){ return i("volta/models/simulation-item-planning.ts");});
d("volta/models/simulation-item-setting-task", function(){ return i("volta/models/simulation-item-setting-task.ts");});
d("volta/models/simulation-item-setting", function(){ return i("volta/models/simulation-item-setting.ts");});
d("volta/models/simulation-scenario", function(){ return i("volta/models/simulation-scenario.ts");});
d("volta/models/simulation-task", function(){ return i("volta/models/simulation-task.ts");});
d("volta/models/simulation", function(){ return i("volta/models/simulation.ts");});
d("volta/models/sku-forecast-type", function(){ return i("volta/models/sku-forecast-type.ts");});
d("volta/models/sku-location", function(){ return i("volta/models/sku-location.ts");});
d("volta/models/sku-supply-alternative", function(){ return i("volta/models/sku-supply-alternative.ts");});
d("volta/models/sku-task", function(){ return i("volta/models/sku-task.ts");});
d("volta/models/sku", function(){ return i("volta/models/sku.ts");});
d("volta/models/source-matching-rule", function(){ return i("volta/models/source-matching-rule.ts");});
d("volta/models/source", function(){ return i("volta/models/source.ts");});
d("volta/models/supplier-calendar-day", function(){ return i("volta/models/supplier-calendar-day.ts");});
d("volta/models/supplier", function(){ return i("volta/models/supplier.ts");});
d("volta/models/tag", function(){ return i("volta/models/tag.ts");});
d("volta/models/task", function(){ return i("volta/models/task.ts");});
d("volta/models/tenant", function(){ return i("volta/models/tenant.ts");});
d("volta/models/transaction", function(){ return i("volta/models/transaction.ts");});
d("volta/models/translation", function(){ return i("volta/models/translation.ts");});
d("volta/models/update-planning-settings-cmd", function(){ return i("volta/models/update-planning-settings-cmd.ts");});
d("volta/models/user-preference", function(){ return i("volta/models/user-preference.ts");});
d("volta/models/user-profile", function(){ return i("volta/models/user-profile.ts");});
d("volta/models/user-role", function(){ return i("volta/models/user-role.ts");});
d("volta/models/user", function(){ return i("volta/models/user.ts");});
d("volta/models/warehouse-calendar-day", function(){ return i("volta/models/warehouse-calendar-day.ts");});
d("volta/models/warehouse", function(){ return i("volta/models/warehouse.ts");});
d("volta/models/workshop-calendar-day", function(){ return i("volta/models/workshop-calendar-day.ts");});
d("volta/models/workshop", function(){ return i("volta/models/workshop.ts");});
d("volta/router", function(){ return i("volta/router.ts");});
d("volta/sentry", function(){ return i("volta/sentry.ts");});
d("volta/serializers/forecast-project-task", function(){ return i("volta/serializers/forecast-project-task.ts");});
d("volta/serializers/po-task", function(){ return i("volta/serializers/po-task.ts");});
d("volta/serializers/simulation-item-setting-task", function(){ return i("volta/serializers/simulation-item-setting-task.ts");});
d("volta/serializers/simulation-task", function(){ return i("volta/serializers/simulation-task.ts");});
d("volta/serializers/sku-task", function(){ return i("volta/serializers/sku-task.ts");});
d("volta/services/_store", function(){ return i("volta/services/_store.ts");});
d("volta/services/adu-ts-data", function(){ return i("volta/services/adu-ts-data.ts");});
d("volta/services/app-nav-state", function(){ return i("volta/services/app-nav-state.ts");});
d("volta/services/app-settings", function(){ return i("volta/services/app-settings.ts");});
d("volta/services/authorization", function(){ return i("volta/services/authorization.ts");});
d("volta/services/bv-flash", function(){ return i("volta/services/bv-flash.ts");});
d("volta/services/bv-metrics", function(){ return i("volta/services/bv-metrics.ts");});
d("volta/services/calendar-service", function(){ return i("volta/services/calendar-service.ts");});
d("volta/services/collection-builder-alerts", function(){ return i("volta/services/collection-builder-alerts.ts");});
d("volta/services/collection-builder-base", function(){ return i("volta/services/collection-builder-base.ts");});
d("volta/services/collection-builder-forecast-projects", function(){ return i("volta/services/collection-builder-forecast-projects.ts");});
d("volta/services/collection-builder-open-orders", function(){ return i("volta/services/collection-builder-open-orders.ts");});
d("volta/services/collection-builder-po-groups", function(){ return i("volta/services/collection-builder-po-groups.ts");});
d("volta/services/collection-builder-reports", function(){ return i("volta/services/collection-builder-reports.ts");});
d("volta/services/collection-builder-skus", function(){ return i("volta/services/collection-builder-skus.ts");});
d("volta/services/collection-builder-sources", function(){ return i("volta/services/collection-builder-sources.ts");});
d("volta/services/collection-builder-suppliers", function(){ return i("volta/services/collection-builder-suppliers.ts");});
d("volta/services/collection-builder-workshops", function(){ return i("volta/services/collection-builder-workshops.ts");});
d("volta/services/custom-field-definitions-service", function(){ return i("volta/services/custom-field-definitions-service.ts");});
d("volta/services/dashboard-stats", function(){ return i("volta/services/dashboard-stats.ts");});
d("volta/services/event-stream", function(){ return i("volta/services/event-stream.ts");});
d("volta/services/execution-alerts-ts-data", function(){ return i("volta/services/execution-alerts-ts-data.ts");});
d("volta/services/label-service", function(){ return i("volta/services/label-service.ts");});
d("volta/services/local-preferences", function(){ return i("volta/services/local-preferences.ts");});
d("volta/services/localization", function(){ return i("volta/services/localization.ts");});
d("volta/services/memory-scroll", function(){ return i("volta/services/memory-scroll.ts");});
d("volta/services/model-enums", function(){ return i("volta/services/model-enums.ts");});
d("volta/services/permissions-cache", function(){ return i("volta/services/permissions-cache.ts");});
d("volta/services/planning-api", function(){ return i("volta/services/planning-api.ts");});
d("volta/services/planning-order-api", function(){ return i("volta/services/planning-order-api.ts");});
d("volta/services/rules-engine-service", function(){ return i("volta/services/rules-engine-service.ts");});
d("volta/services/scroll-lock-manager", function(){ return i("volta/services/scroll-lock-manager.ts");});
d("volta/services/sentry-service", function(){ return i("volta/services/sentry-service.ts");});
d("volta/services/session-user", function(){ return i("volta/services/session-user.ts");});
d("volta/services/session", function(){ return i("volta/services/session.ts");});
d("volta/services/sku-modal-service", function(){ return i("volta/services/sku-modal-service.ts");});
d("volta/services/store", function(){ return i("volta/services/store.js");});
d("volta/services/task-service", function(){ return i("volta/services/task-service.ts");});
d("volta/services/ts-base-service", function(){ return i("volta/services/ts-base-service.ts");});
d("volta/session-stores/application", function(){ return i("volta/session-stores/application.ts");});
d("volta/transforms/array", function(){ return i("volta/transforms/array.ts");});
d("volta/transforms/boolean", function(){ return i("volta/transforms/boolean.js");});
d("volta/transforms/date", function(){ return i("volta/transforms/date.js");});
d("volta/transforms/number", function(){ return i("volta/transforms/number.js");});
d("volta/transforms/string", function(){ return i("volta/transforms/string.js");});
d("volta/utils/adu-utils", function(){ return i("volta/utils/adu-utils.ts");});
d("volta/utils/api/build-url", function(){ return i("volta/utils/api/build-url.ts");});
d("volta/utils/api/collection-command", function(){ return i("volta/utils/api/collection-command.ts");});
d("volta/utils/api/index", function(){ return i("volta/utils/api/index.ts");});
d("volta/utils/api/jsonapi-types", function(){ return i("volta/utils/api/jsonapi-types.ts");});
d("volta/utils/api/resource-command", function(){ return i("volta/utils/api/resource-command.ts");});
d("volta/utils/api/serialize-and-push", function(){ return i("volta/utils/api/serialize-and-push.ts");});
d("volta/utils/api/types", function(){ return i("volta/utils/api/types.ts");});
d("volta/utils/application", function(){ return i("volta/utils/application.ts");});
d("volta/utils/array-utils", function(){ return i("volta/utils/array-utils.ts");});
d("volta/utils/chart-utils", function(){ return i("volta/utils/chart-utils.ts");});
d("volta/utils/column-utils", function(){ return i("volta/utils/column-utils.ts");});
d("volta/utils/cron-utils", function(){ return i("volta/utils/cron-utils.ts");});
d("volta/utils/daf-utils", function(){ return i("volta/utils/daf-utils.ts");});
d("volta/utils/date-utils", function(){ return i("volta/utils/date-utils.ts");});
d("volta/utils/dom-utils", function(){ return i("volta/utils/dom-utils.ts");});
d("volta/utils/error-utils", function(){ return i("volta/utils/error-utils.ts");});
d("volta/utils/filters-utils", function(){ return i("volta/utils/filters-utils.ts");});
d("volta/utils/focus", function(){ return i("volta/utils/focus.ts");});
d("volta/utils/group-utils", function(){ return i("volta/utils/group-utils.ts");});
d("volta/utils/id", function(){ return i("volta/utils/id.ts");});
d("volta/utils/intl/missing-message", function(){ return i("volta/utils/intl/missing-message.ts");});
d("volta/utils/math-utils", function(){ return i("volta/utils/math-utils.ts");});
d("volta/utils/object-utils", function(){ return i("volta/utils/object-utils.ts");});
d("volta/utils/planning-supply-alternatives", function(){ return i("volta/utils/planning-supply-alternatives.ts");});
d("volta/utils/power-calendar/library", function(){ return i("volta/utils/power-calendar/library.ts");});
d("volta/utils/route-utils", function(){ return i("volta/utils/route-utils.ts");});
d("volta/utils/style-utils", function(){ return i("volta/utils/style-utils.ts");});
d("volta/utils/text-utils", function(){ return i("volta/utils/text-utils.ts");});
d("volta/utils/validate-formula", function(){ return i("volta/utils/validate-formula.ts");});
d("volta/utils/workshop-exceptions-utils", function(){ return i("volta/utils/workshop-exceptions-utils.ts");});
d("volta/validations/adu-profile", function(){ return i("volta/validations/adu-profile.ts");});
d("volta/validations/buffer-profile", function(){ return i("volta/validations/buffer-profile.ts");});
d("volta/validations/custom-field", function(){ return i("volta/validations/custom-field.ts");});
d("volta/validations/daf-profile", function(){ return i("volta/validations/daf-profile.ts");});
d("volta/validations/messages", function(){ return i("volta/validations/messages.js");});
d("volta/validations/planning-order", function(){ return i("volta/validations/planning-order.ts");});
d("volta/validations/planning-setting-rule", function(){ return i("volta/validations/planning-setting-rule.ts");});
d("volta/validations/schedule", function(){ return i("volta/validations/schedule.ts");});
d("volta/validations/settings-features", function(){ return i("volta/validations/settings-features.ts");});
d("volta/validations/source-matching-rule", function(){ return i("volta/validations/source-matching-rule.ts");});
d("volta/validations/supplier", function(){ return i("volta/validations/supplier.ts");});
d("volta/validations/task", function(){ return i("volta/validations/task.ts");});
d("volta/validations/update-many-po", function(){ return i("volta/validations/update-many-po.ts");});
d("volta/validations/update-many-skus", function(){ return i("volta/validations/update-many-skus.ts");});
d("volta/validations/update-planning-settings", function(){ return i("volta/validations/update-planning-settings.ts");});
d("volta/validations/update-sku", function(){ return i("volta/validations/update-sku.ts");});
d("volta/validations/user-role", function(){ return i("volta/validations/user-role.ts");});
d("volta/validations/user", function(){ return i("volta/validations/user.ts");});
d("volta/validations/warehouse", function(){ return i("volta/validations/warehouse.ts");});
d("volta/validations/workshop", function(){ return i("volta/validations/workshop.ts");});
d("volta/validators/check-date", function(){ return i("volta/validators/check-date.ts");});
d("volta/validators/check-formula", function(){ return i("volta/validators/check-formula.ts");});
d("volta/validators/check-table-columns", function(){ return i("volta/validators/check-table-columns.ts");});
d("volta/validators/compare-date", function(){ return i("volta/validators/compare-date.ts");});
d("volta/validators/on-check", function(){ return i("volta/validators/on-check.ts");});
d("volta/validators/validate-array-inclusion", function(){ return i("volta/validators/validate-array-inclusion.ts");});
d("volta/validators/validate-cron", function(){ return i("volta/validators/validate-cron.ts");});
d("volta/version", function(){ return i("volta/version.ts");});
d("volta/services/-ea-motion", function(){ return i("volta/services/-ea-motion.js");});
d("volta/services/cookies", function(){ return i("volta/services/cookies.js");});
d("volta/data-adapter", function(){ return i("volta/data-adapter.js");});
d("volta/initializers/ember-data", function(){ return i("volta/initializers/ember-data.js");});
d("volta/services/file-queue", function(){ return i("volta/services/file-queue.js");});
d("volta/services/infinity", function(){ return i("volta/services/infinity.js");});
d("volta/services/keyboard", function(){ return i("volta/services/keyboard.js");});
d("volta/services/moment", function(){ return i("volta/services/moment.js");});
d("volta/services/page-title", function(){ return i("volta/services/page-title.js");});
d("volta/services/power-calendar", function(){ return i("volta/services/power-calendar.js");});
d("volta/test-support/helpers", function(){ return i("volta/test-support/helpers.js");});
d("volta/initializers/ember-simple-auth", function(){ return i("volta/initializers/ember-simple-auth.js");});
d("volta/authenticators/jwt", function(){ return i("volta/authenticators/jwt.js");});
d("volta/authenticators/token", function(){ return i("volta/authenticators/token.js");});
d("volta/services/ember-sortable-internal-state", function(){ return i("volta/services/ember-sortable-internal-state.js");});
d("volta/instance-initializers/sentry-performance", function(){ return i("volta/instance-initializers/sentry-performance.js");});
d("volta/services/-ensure-registered", function(){ return i("volta/services/-ensure-registered.js");});
d("volta/initializers/app-version", function(){ return i("volta/initializers/app-version.js");});
d("volta/initializers/install-function-modifier-manager", function(){ return i("volta/initializers/install-function-modifier-manager.js");});
d("volta/initializers/viewport-config", function(){ return i("volta/initializers/viewport-config.js");});
d("volta/services/in-viewport", function(){ return i("volta/services/in-viewport.js");});
d("volta/services/intl", function(){ return i("volta/services/intl.js");});
d("volta/metrics-adapters/base", function(){ return i("volta/metrics-adapters/base.js");});
d("volta/metrics-adapters/google-analytics", function(){ return i("volta/metrics-adapters/google-analytics.js");});
d("volta/services/metrics", function(){ return i("volta/services/metrics.js");});
d("volta/services/resize-observer", function(){ return i("volta/services/resize-observer.js");});
d("volta/instance-initializers/global-ref-cleanup", function(){ return i("volta/instance-initializers/global-ref-cleanup.js");});
d("volta/initializers/ember-responsive-breakpoints", function(){ return i("volta/initializers/ember-responsive-breakpoints.js");});
d("volta/services/media", function(){ return i("volta/services/media.js");});
d("volta/services/body-class", function(){ return i("volta/services/body-class.js");});
d("volta/services/socket-io", function(){ return i("volta/services/socket-io.js");});
d("volta/services/websockets", function(){ return i("volta/services/websockets.js");});
d("volta/_pods/application/template", function(){ return i("volta/_pods/application/template.ts");});
d("volta/_pods/application/controller", function(){ return i("volta/_pods/application/controller.ts");});
d("volta/_pods/application/route", function(){ return i("volta/_pods/application/route.ts");});
d("volta/controllers/resource-controller", function(){ return i("volta/controllers/resource-controller.ts");});
d("volta/routes/base", function(){ return i("volta/routes/base.ts");});
d("volta/templates/loading", function(){ return i("volta/templates/loading.ts");});
d("volta/templates/login-error", function(){ return i("volta/templates/login-error.ts");});
d("volta/templates/login-loading", function(){ return i("volta/templates/login-loading.ts");});

  if (macroCondition(getGlobalConfig().fastboot?.isRunning)) {
d("volta/instance-initializers/content-security-policy", function(){ return i("volta/instance-initializers/content-security-policy.js");});
  }


w._embroiderRouteBundles_ = [
  {
    names: ["login"],
    load: function() {
      return import("volta/assets/_route_/login.js");
    }
  },
  {
    names: ["not-found"],
    load: function() {
      return import("volta/assets/_route_/not-found.js");
    }
  },
  {
    names: ["protected.account.activities"],
    load: function() {
      return import("volta/assets/_route_/protected.account.activities.js");
    }
  },
  {
    names: ["protected.account.preferences"],
    load: function() {
      return import("volta/assets/_route_/protected.account.preferences.js");
    }
  },
  {
    names: ["protected.account.profile"],
    load: function() {
      return import("volta/assets/_route_/protected.account.profile.js");
    }
  },
  {
    names: ["protected.account"],
    load: function() {
      return import("volta/assets/_route_/protected.account.js");
    }
  },
  {
    names: ["protected.adu-profile-create"],
    load: function() {
      return import("volta/assets/_route_/protected.adu-profile-create.js");
    }
  },
  {
    names: ["protected.adu-profile"],
    load: function() {
      return import("volta/assets/_route_/protected.adu-profile.js");
    }
  },
  {
    names: ["protected.adu-profiles"],
    load: function() {
      return import("volta/assets/_route_/protected.adu-profiles.js");
    }
  },
  {
    names: ["protected.alerts.sku"],
    load: function() {
      return import("volta/assets/_route_/protected.alerts.sku.js");
    }
  },
  {
    names: ["protected.alerts"],
    load: function() {
      return import("volta/assets/_route_/protected.alerts.js");
    }
  },
  {
    names: ["protected.bom.sku"],
    load: function() {
      return import("volta/assets/_route_/protected.bom.sku.js");
    }
  },
  {
    names: ["protected.bom"],
    load: function() {
      return import("volta/assets/_route_/protected.bom.js");
    }
  },
  {
    names: ["protected.boms.sku"],
    load: function() {
      return import("volta/assets/_route_/protected.boms.sku.js");
    }
  },
  {
    names: ["protected.boms"],
    load: function() {
      return import("volta/assets/_route_/protected.boms.js");
    }
  },
  {
    names: ["protected.buffer-profile-create"],
    load: function() {
      return import("volta/assets/_route_/protected.buffer-profile-create.js");
    }
  },
  {
    names: ["protected.buffer-profile"],
    load: function() {
      return import("volta/assets/_route_/protected.buffer-profile.js");
    }
  },
  {
    names: ["protected.buffer-profiles"],
    load: function() {
      return import("volta/assets/_route_/protected.buffer-profiles.js");
    }
  },
  {
    names: ["protected.custom-field-definition"],
    load: function() {
      return import("volta/assets/_route_/protected.custom-field-definition.js");
    }
  },
  {
    names: ["protected.custom-field-definitions-create"],
    load: function() {
      return import("volta/assets/_route_/protected.custom-field-definitions-create.js");
    }
  },
  {
    names: ["protected.custom-field-definitions"],
    load: function() {
      return import("volta/assets/_route_/protected.custom-field-definitions.js");
    }
  },
  {
    names: ["protected.daf-profile-create"],
    load: function() {
      return import("volta/assets/_route_/protected.daf-profile-create.js");
    }
  },
  {
    names: ["protected.daf-profile"],
    load: function() {
      return import("volta/assets/_route_/protected.daf-profile.js");
    }
  },
  {
    names: ["protected.daf-profiles"],
    load: function() {
      return import("volta/assets/_route_/protected.daf-profiles.js");
    }
  },
  {
    names: ["protected.dashboard"],
    load: function() {
      return import("volta/assets/_route_/protected.dashboard.js");
    }
  },
  {
    names: ["protected.forecast-project-create"],
    load: function() {
      return import("volta/assets/_route_/protected.forecast-project-create.js");
    }
  },
  {
    names: ["protected.forecast-project-revision"],
    load: function() {
      return import("volta/assets/_route_/protected.forecast-project-revision.js");
    }
  },
  {
    names: ["protected.forecast-project"],
    load: function() {
      return import("volta/assets/_route_/protected.forecast-project.js");
    }
  },
  {
    names: ["protected.forecast-projects"],
    load: function() {
      return import("volta/assets/_route_/protected.forecast-projects.js");
    }
  },
  {
    names: ["protected.import"],
    load: function() {
      return import("volta/assets/_route_/protected.import.js");
    }
  },
  {
    names: ["protected.jobs"],
    load: function() {
      return import("volta/assets/_route_/protected.jobs.js");
    }
  },
  {
    names: ["protected.my-tasks"],
    load: function() {
      return import("volta/assets/_route_/protected.my-tasks.js");
    }
  },
  {
    names: ["protected.open-orders.sku"],
    load: function() {
      return import("volta/assets/_route_/protected.open-orders.sku.js");
    }
  },
  {
    names: ["protected.open-orders"],
    load: function() {
      return import("volta/assets/_route_/protected.open-orders.js");
    }
  },
  {
    names: ["protected.operator-workbench"],
    load: function() {
      return import("volta/assets/_route_/protected.operator-workbench.js");
    }
  },
  {
    names: ["protected.planning-setting-rule"],
    load: function() {
      return import("volta/assets/_route_/protected.planning-setting-rule.js");
    }
  },
  {
    names: ["protected.planning-setting-rules-create"],
    load: function() {
      return import("volta/assets/_route_/protected.planning-setting-rules-create.js");
    }
  },
  {
    names: ["protected.planning-setting-rules"],
    load: function() {
      return import("volta/assets/_route_/protected.planning-setting-rules.js");
    }
  },
  {
    names: ["protected.plannings.sku"],
    load: function() {
      return import("volta/assets/_route_/protected.plannings.sku.js");
    }
  },
  {
    names: ["protected.plannings"],
    load: function() {
      return import("volta/assets/_route_/protected.plannings.js");
    }
  },
  {
    names: ["protected.po-workbench-validation-rule"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench-validation-rule.js");
    }
  },
  {
    names: ["protected.po-workbench-validation-rules-create"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench-validation-rules-create.js");
    }
  },
  {
    names: ["protected.po-workbench-validation-rules"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench-validation-rules.js");
    }
  },
  {
    names: ["protected.po-workbench.line.activities"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench.line.activities.js");
    }
  },
  {
    names: ["protected.po-workbench.line.index"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench.line.index.js");
    }
  },
  {
    names: ["protected.po-workbench.line.operations"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench.line.operations.js");
    }
  },
  {
    names: ["protected.po-workbench.line.tasks"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench.line.tasks.js");
    }
  },
  {
    names: ["protected.po-workbench.line"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench.line.js");
    }
  },
  {
    names: ["protected.po-workbench.sku"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench.sku.js");
    }
  },
  {
    names: ["protected.po-workbench"],
    load: function() {
      return import("volta/assets/_route_/protected.po-workbench.js");
    }
  },
  {
    names: ["protected.report"],
    load: function() {
      return import("volta/assets/_route_/protected.report.js");
    }
  },
  {
    names: ["protected.reports"],
    load: function() {
      return import("volta/assets/_route_/protected.reports.js");
    }
  },
  {
    names: ["protected.schedule-create"],
    load: function() {
      return import("volta/assets/_route_/protected.schedule-create.js");
    }
  },
  {
    names: ["protected.schedule-duplicate"],
    load: function() {
      return import("volta/assets/_route_/protected.schedule-duplicate.js");
    }
  },
  {
    names: ["protected.schedule"],
    load: function() {
      return import("volta/assets/_route_/protected.schedule.js");
    }
  },
  {
    names: ["protected.schedules"],
    load: function() {
      return import("volta/assets/_route_/protected.schedules.js");
    }
  },
  {
    names: ["protected.settings.admin"],
    load: function() {
      return import("volta/assets/_route_/protected.settings.admin.js");
    }
  },
  {
    names: ["protected.settings.features"],
    load: function() {
      return import("volta/assets/_route_/protected.settings.features.js");
    }
  },
  {
    names: ["protected.settings.general"],
    load: function() {
      return import("volta/assets/_route_/protected.settings.general.js");
    }
  },
  {
    names: ["protected.settings.rules"],
    load: function() {
      return import("volta/assets/_route_/protected.settings.rules.js");
    }
  },
  {
    names: ["protected.settings"],
    load: function() {
      return import("volta/assets/_route_/protected.settings.js");
    }
  },
  {
    names: ["protected.simulation-create"],
    load: function() {
      return import("volta/assets/_route_/protected.simulation-create.js");
    }
  },
  {
    names: ["protected.simulation-duplicate"],
    load: function() {
      return import("volta/assets/_route_/protected.simulation-duplicate.js");
    }
  },
  {
    names: ["protected.simulation.scenario.item"],
    load: function() {
      return import("volta/assets/_route_/protected.simulation.scenario.item.js");
    }
  },
  {
    names: ["protected.simulation.scenario.report"],
    load: function() {
      return import("volta/assets/_route_/protected.simulation.scenario.report.js");
    }
  },
  {
    names: ["protected.simulation.scenario"],
    load: function() {
      return import("volta/assets/_route_/protected.simulation.scenario.js");
    }
  },
  {
    names: ["protected.simulation"],
    load: function() {
      return import("volta/assets/_route_/protected.simulation.js");
    }
  },
  {
    names: ["protected.simulations"],
    load: function() {
      return import("volta/assets/_route_/protected.simulations.js");
    }
  },
  {
    names: ["protected.sku-create"],
    load: function() {
      return import("volta/assets/_route_/protected.sku-create.js");
    }
  },
  {
    names: ["protected.sku-duplicate"],
    load: function() {
      return import("volta/assets/_route_/protected.sku-duplicate.js");
    }
  },
  {
    names: ["protected.sku"],
    load: function() {
      return import("volta/assets/_route_/protected.sku.js");
    }
  },
  {
    names: ["protected.skus.sku"],
    load: function() {
      return import("volta/assets/_route_/protected.skus.sku.js");
    }
  },
  {
    names: ["protected.skus"],
    load: function() {
      return import("volta/assets/_route_/protected.skus.js");
    }
  },
  {
    names: ["protected.source-create"],
    load: function() {
      return import("volta/assets/_route_/protected.source-create.js");
    }
  },
  {
    names: ["protected.source-matching-rule"],
    load: function() {
      return import("volta/assets/_route_/protected.source-matching-rule.js");
    }
  },
  {
    names: ["protected.source-matching-rules-create"],
    load: function() {
      return import("volta/assets/_route_/protected.source-matching-rules-create.js");
    }
  },
  {
    names: ["protected.source-matching-rules"],
    load: function() {
      return import("volta/assets/_route_/protected.source-matching-rules.js");
    }
  },
  {
    names: ["protected.source"],
    load: function() {
      return import("volta/assets/_route_/protected.source.js");
    }
  },
  {
    names: ["protected.sources"],
    load: function() {
      return import("volta/assets/_route_/protected.sources.js");
    }
  },
  {
    names: ["protected.supplier-create"],
    load: function() {
      return import("volta/assets/_route_/protected.supplier-create.js");
    }
  },
  {
    names: ["protected.supplier"],
    load: function() {
      return import("volta/assets/_route_/protected.supplier.js");
    }
  },
  {
    names: ["protected.suppliers"],
    load: function() {
      return import("volta/assets/_route_/protected.suppliers.js");
    }
  },
  {
    names: ["protected.user-create"],
    load: function() {
      return import("volta/assets/_route_/protected.user-create.js");
    }
  },
  {
    names: ["protected.user-role-create"],
    load: function() {
      return import("volta/assets/_route_/protected.user-role-create.js");
    }
  },
  {
    names: ["protected.user-role"],
    load: function() {
      return import("volta/assets/_route_/protected.user-role.js");
    }
  },
  {
    names: ["protected.user-roles"],
    load: function() {
      return import("volta/assets/_route_/protected.user-roles.js");
    }
  },
  {
    names: ["protected.user"],
    load: function() {
      return import("volta/assets/_route_/protected.user.js");
    }
  },
  {
    names: ["protected.users"],
    load: function() {
      return import("volta/assets/_route_/protected.users.js");
    }
  },
  {
    names: ["protected.warehouse-create"],
    load: function() {
      return import("volta/assets/_route_/protected.warehouse-create.js");
    }
  },
  {
    names: ["protected.warehouse"],
    load: function() {
      return import("volta/assets/_route_/protected.warehouse.js");
    }
  },
  {
    names: ["protected.warehouses"],
    load: function() {
      return import("volta/assets/_route_/protected.warehouses.js");
    }
  },
  {
    names: ["protected.workshop-create"],
    load: function() {
      return import("volta/assets/_route_/protected.workshop-create.js");
    }
  },
  {
    names: ["protected.workshop"],
    load: function() {
      return import("volta/assets/_route_/protected.workshop.js");
    }
  },
  {
    names: ["protected.workshops"],
    load: function() {
      return import("volta/assets/_route_/protected.workshops.js");
    }
  },
  {
    names: ["protected"],
    load: function() {
      return import("volta/assets/_route_/protected.js");
    }
  },
  {
    names: ["protected-controller"],
    load: function() {
      return import("volta/assets/_route_/protected-controller.js");
    }
  },
]


if (!runningTests) {
  i("../app").default.create({"tenant":"VOLTA_TENANT_ID","env":"VOLTA_TENANT_ENV","customColumns":{"executionAlerts":"VOLTA_CUSTOM_COLS_EXECUTION","openOrders":"VOLTA_CUSTOM_COLS_ORDERS"},"name":"volta","version":"26.3.12+c51c0b05"});
}

